(function () {
  'use strict';
  if (window.agbPreorderInitialized) return;
  window.agbPreorderInitialized = true;

  // The theme's AJAX cart reads properties from this container, not FormData.
  function prepareProperties() {
    document.querySelectorAll('.agb-preorder-property').forEach(function (property) {
      var form = property.closest('form');
      if (!form) return;
      var container = form.querySelector('.js-product-properties');
      if (!container) {
        container = document.createElement('div');
        container.className = 'js-product-properties';
        form.appendChild(container);
      }
      if (property.parentElement !== container) container.appendChild(property);
    });
  }
  prepareProperties();
  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-product-add-to-cart-button')) prepareProperties();
  }, true);
  document.addEventListener('submit', prepareProperties, true);
  document.addEventListener('shopify:section:load', prepareProperties);
}());
